function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-download");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Detail",
  transform: "translate(-1154.000000, -689.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Actions",
  transform: "translate(1143.000000, 680.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Archive"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-download",
  transform: "translate(11.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,12.59 L8,1 C8,0.44771525 8.44771525,0 9,0 C9.55228475,0 10,0.44771525 10,1 L10,12.59 L13.3,9.29 C13.6991459,8.95283474 14.290578,8.97978463 14.6574061,9.35185316 C15.0242342,9.72392169 15.0427927,10.3156765 14.7,10.71 L9.7,15.71 C9.31115649,16.0911429 8.68884351,16.0911429 8.3,15.71 L3.3,10.71 C2.9572073,10.3156765 2.97576579,9.72392169 3.34259392,9.35185316 C3.70942204,8.97978463 4.3008541,8.95283474 4.7,9.29 L8,12.59 Z M0,15 C0,14.4477153 0.44771525,14 1,14 C1.55228475,14 2,14.4477153 2,15 L2,18 L16,18 L16,15 C16,14.4477153 16.4477153,14 17,14 C17.5522847,14 18,14.4477153 18,15 L18,18 C18,19.1045695 17.1045695,20 16,20 L2,20 C0.8954305,20 0,19.1045695 0,18 L0,15 Z",
  id: "Shape"
}))))));

var SvgArchive = function SvgArchive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArchive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/archive.4ba5ec59.svg";
export { ForwardRef as ReactComponent };